import React from "react";
import ProviderSelectGrid from "../../components/ProviderSelectGrid";

const PgPayoutSelect = () => (
  <ProviderSelectGrid
    service="PG_PAYOUT"
    title="Select payout provider"
    description="Only admin-activated providers are listed. Each version uses its own checkout flow."
    breadcrumbs={[
      { label: "Dashboard", to: "/dashboard" },
      { label: "PG + Payout" },
    ]}
    fallbackPath="/pg-payout"
  />
);

export default PgPayoutSelect;
